/* eslint-disable */
export const region9Barangays = [
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'BACUNGAN (POB.)',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'BOGABONGAN',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'DELUSOM',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'MANGOP',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'MANIL',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'MAWAL',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'MIDATAG',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'MOROB',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'NASIBAC',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'RIZON',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'SIPACONG',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TALINGA',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TINAPLAN',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TINIGUIBAN',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TINUYOP',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TIOGAN',
    },
    {
        CITY: 'BACUNGAN',
        BARANGAY: 'TITIK',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'DIANGAS',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'DICULOM',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'GUIMOTAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'KILALABAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'LINAY',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'LUMAY',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'MAMAD',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'MAMAWAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'MILIDAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'NONOYAN',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'TAMAO',
    },
    {
        CITY: 'BALIGUIAN',
        BARANGAY: 'TAN-AWAN',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'ALIGUAY',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'ASENIERO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'BA-AO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'BAGTING (POB.)',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'BANBANAN',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'BANONONG (POB.)',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'BARCELONA',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'BAYLIMANGO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'CANLUCANI',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'CARANG',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'CAWA-CAWA (POB.)',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'DAMPALAN',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'DARO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'DAWO (POB.)',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'DIWA-AN',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'GUIMPUTLAN',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'HILLTOP',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'KAUSWAGAN (TALISAY)',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'LARAYAN',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'LINABO (POB.)',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'LIYANG',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'MARIA CRISTINA',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'MARIA URAY',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'MASIDLAKON',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'MATAGOBTOB POB. (TALISAY)',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'OPAO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'ORO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'OWAON',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'OYAN',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'POTOL (POB.)',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'POTUNGAN',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SICAYAB BOCANA',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SIGAYAN',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SILINOG',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SINONOC',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'SULANGON',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'TAG-OLO',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'TAGUILON',
    },
    {
        CITY: 'DAPITAN',
        BARANGAY: 'TAMION',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'BARRA (POB.)',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'BIASONG (POB.)',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'DICAYAS',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'DIWAN',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'ESTACA (POB.)',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'GALAS',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'GULAYON',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'LUGDUNGAN',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'MINAOG',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'MIPUTAK (POB.)',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'OLINGAN',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'SANGKOL',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'SICAYAB',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'SINAMAN',
    },
    {
        CITY: 'DIPOLOG',
        BARANGAY: 'TURNO',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'BALUNO',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'BANUANGAN',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'BUNAWAN',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'DILUCOT',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'DIPOPOR',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'GUISAPONG',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'LIMBONGA (LIMBOANGAN)',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'LOMOGOM',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'MIAMPIC',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'RABA',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'RAMBON',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'SARAWAGAN',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'SIANAN',
    },
    {
        CITY: 'GODOD',
        BARANGAY: 'SIORAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'BANGANON',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'BAYANIHAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'CANUPONG',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'COCOB',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'IMMACULADA CONCEPCION',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'LA LIBERTAD',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'LOAY',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'LOWER LUX',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'LUX',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'MALIAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'MAMAWAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'MAP',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'MATUNOY',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'NEW DAPITAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'PANGANURAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'PITAWE',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'POBLACION (GUTALAC)',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SALVADOR',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SAS',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'SIBALIC',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'TIPAN',
    },
    {
        CITY: 'GUTALAC',
        BARANGAY: 'UPPER GUTALAC',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'BALATAKAN',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'BITOON',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'DINASAN',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'LABAKID',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'LIPAY',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'LITALIP',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'LOPERO',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'LUMANPING',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'MADALAG',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'MANAWAN',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'MARUPAY',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'POBLACION (PONOT)',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'SIGAMOK',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'SIPAROK',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'TAMAROK',
    },
    {
        CITY: 'JOSE-DALMAN',
        BARANGAY: 'TAMIL',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'BATAYAN',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'BOTONG',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'DANIEL MAING (DOMINOLOG)',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'FATIMA (LACSUTAN)',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'GATAS',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'KALAWIT (POB.)',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'MARCELO',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'NEW CALAMBA',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'PALALIAN',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'PIANON',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'KALAWIT',
        BARANGAY: 'TUGOP',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BALOK',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BARANGAY DOS (POB.)',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BARANGAY UNO (POB.)',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BASAGAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BINIRAY',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'CARUPAY',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'DAANGLUNGSOD',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'DABIAK',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'DR. JOSE RIZAL (LOWER MIAS)',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'FIMAGAS',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'LOYURAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'MALASAY',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'MALUGAS',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'MATAM',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'MIAS',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'MIATAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'NANGINAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'NEW TAMBO',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'PATIK',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SAN ANTONIO (LOOY)',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SANAO',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SERES',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SEROAN',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SINGATONG',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SINUYAK',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'SITOG',
    },
    {
        CITY: 'KATIPUNAN',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'ANTONINO (POB.)',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'BALAS',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'BOBONGAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'DANSALAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'GABU',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'GIL SANCHEZ',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'IMMACULADA',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'KIPIT',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'LAPATAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'LAWAGAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'LAWIGAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'LOPOC (POB.)',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'MALINTUBOAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'NEW SALVACION',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'OSUKAN',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'PATAWAG',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LABASON',
        BARANGAY: 'UBAY',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'EL PARAISO',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'LA VICTORIA',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'NEW ARGAO',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'NEW BATAAN',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'NEW CARCAR',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'SINGARAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'BANIGAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'BAYBAY (POB.)',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'CABANGCALAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'CANAAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'CANDELARIA',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'CAUSWAGAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'COMMUNAL',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'COMPRA',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'DELA PAZ',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'EL PARAISO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'GANASE',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'GOAW',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'GOIN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'KAYOK',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'LA LIBERTAD (MAWAL)',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'LAMAO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'MAIGANG',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'MALILA',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'MAUSWAGON',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'NEW BETHLEHEM',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'OVERVIEW',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'PANABANG',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'PATAWAG',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'SILUCAP',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'TAPICAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'TIMAN',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'VILLA CALIXTO SUDIACAL',
    },
    {
        CITY: 'LILOY',
        BARANGAY: 'VILLA M. TEJERO',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'DIPANE',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'DISAKAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'DON JOSE AGUIRRE',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'EAST POBLACION',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'GUPOT',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'LIBUTON',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'LINAY',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'LINGATONGAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'LUPASANG',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'MATE',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'MESES',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'PALARANAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'PANGANDAO',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'PATAGAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'PUNTA BLANCA',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'SALUYONG',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'SERONGAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'SUISAYAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'UPPER DISAKAN',
    },
    {
        CITY: 'MANUKAN',
        BARANGAY: 'VILLARAMOS',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'ALVENDA',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'DILAND',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'DIOLEN',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'HEAD TIPAN',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'NEW CASUL',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'NEW SIQUIJOR',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'NEWLAND',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'PASO RIO',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'TINGLAN',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'TOTONGON',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'TUBAC',
    },
    {
        CITY: 'MUTIA',
        BARANGAY: 'UNIDOS',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'ADANTE',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'BACUYONG',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'CALICAN',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'DESIN',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'DILAWA',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'DIONUM',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'LAPU-LAPU',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'LOWER GUMAY',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'LUZVILLA',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'SEGABE',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'SIKITAN',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'SILANO',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'TERESITA',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'TINAYTAYAN',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'UBAY (DAAN TIPAN)',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'UPPER GUMAY',
    },
    {
        CITY: 'PINAN',
        BARANGAY: 'VILLARICO',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'ANASTACIO',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'BANDERA',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'BETHLEHEM',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'DANGI',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'DANSULLAN',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'DE VENTA PERLA',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'GUINLES',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'ISIS',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'LABRADOR (PRINDA)',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'LAPAYANBAJA',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'LETAPAN',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'LINABO',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'LINGASAD',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'MACLEODES',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'MAGANGON',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'MILAD',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'NEW LEBANGON',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'NEW SICAYAB',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'OBAY',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'PIAN',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SAN ANTONIO (PAETAN)',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SAN MIGUEL (LOBOC)',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SANTO NINO (LANTOY)',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SIANIB',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'SILAWE',
    },
    {
        CITY: 'POLANCO',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'BALUBO',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'BANBANAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'CANIBONGAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'CAPASE',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'CAPE',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'DENOMAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'DOHINOB',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'GALOKSO',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'GUBAT',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'IRASAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'LABAKID',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'LANGATIAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'LIPAKAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'MARUPAY',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'MOLITON',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'NABILID',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PANAMPALAY',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PANGOLOGON',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PIAO',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PINALAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PINAMAR',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'PONGOLAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'SALISIG',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'SEBOD',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'SIBATOG',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'SITUBO',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'TANAYAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'TANTINGON',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'UPPER IRASAN',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'UPPER MINANG',
    },
    {
        CITY: 'PRES.-MANUEL-A.-ROXAS',
        BARANGAY: 'VILLAHERMOSO',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'BALAKAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'BINONI',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'CALUCAP',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'CANAWAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'CARACOL',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'DINOAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'DIPOLOD',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'FATIMA (POGAN)',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'IPILAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'LANAWAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'LIGUAC',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'LIPAKAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'MUCAS',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'PACUHAN',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'POBLACION (SALUG)',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'PUKAY',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'RAMON MAGSAYSAY',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'TAMBALANG',
    },
    {
        CITY: 'SALUG',
        BARANGAY: 'TAPALAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'ANTONINO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'BAGONG BAGUIO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'BIAYON',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'DAMPALAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'DON ELENO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'LABIRAY',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'LIWANAG',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'MACALIBRE',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'MARAPONG',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'NAZARETH',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'NEBO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'NEW RIZAL',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'NEW TANGUB',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'NUEVAVISTA',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'PEDAGAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'PENACIO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'POBLACION ALTO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'POBLACION BAJO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'PRINCESA FRESHIA',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'PRINCESA LAMAYA',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SINAAD',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SINAI',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'SITUBO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'TININDUGAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'VENUS',
    },
    {
        CITY: 'SERGIO-OSMENA-SR.',
        BARANGAY: 'WILBEN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'BALOK',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'BALUNOKAN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'DENOYAN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'DIONGAN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'DOMOGOK',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'DUMPILAS',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'GONAYEN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'GUIBO',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'GUNYAN',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'LITOLET',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'MACASING',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'MANGILAY',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'MOYO',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'MUNOZ',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'PANGE',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'PARANGLUMBA (POB.)',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'POLAYO',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'SAYAW',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'SERIAC',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'SIAYAN PROPER (POB.)',
    },
    {
        CITY: 'SIAYAN',
        BARANGAY: 'SUGUILON',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'ANONGAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'BONGALAO',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'CABBUNAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'CAWIT-CAWIT',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'CULAGUAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'CUSIPAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'DINULAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'JATIAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'KAMARANGAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LAKIKI',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LAMBAGOAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LIMPAPA',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LINGAYON',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LINTANGAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LITAWAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'LUNDAY',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'MALAYAL',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'MANTIVO',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'NALA (POB.)',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'PANGANURAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'PANGIAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'PANIRAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'PASILNAHUT',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'PULIRAN',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'SANTO NINO (CULABOG)',
    },
    {
        CITY: 'SIBUCO',
        BARANGAY: 'TANGARAK',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'CALILIC',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'CALUBE',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'DELAPA',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'KANIM',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'LIBAY',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'MARAPONG',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'MINLASAG',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'OYAN',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'PANGANURAN',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'POBLACION (SIBUTAD)',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'SIBULOC',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'SINIPAY',
    },
    {
        CITY: 'SIBUTAD',
        BARANGAY: 'SIPALOC',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BAGO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BALOK',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BENIGNO AQUINO JR.',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BINUANGAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BITOON',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'BUCANA',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'CALATUNAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'CALUAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'CALUBIAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DAGOHOY',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DAPAON',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DATU TANGKILAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DICOYONG',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DISUD',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DON RICARDO MACIAS (DINOBOT)',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DONA JOSEFA',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'DUMALOGDOG',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'GAMPIS',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'GOLEO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'INUMAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'JOAQUIN MACIAS',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LA CONCEPCION',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LA ROCHE SAN MIGUEL',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LABAKID',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LAGAG',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LAPERO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'LAWIS',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MANDIH',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MARAS',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MAWAL',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MISOK',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'MOTIBOT',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'NATO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'NIPAAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'PANGALALAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'PIAO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'SIARE',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'TALINGA',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'TINAPLAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'TITIK',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'UPPER INUMAN',
    },
    {
        CITY: 'SINDANGAN',
        BARANGAY: 'UPPER NIPAAN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'ANDRES MICUBO JR. (BALILI)',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'BALAGUNAN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'BUCANA',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'BULACAN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'CANDIZ',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'DATU SAILILA',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'DIONISIO RICONALLA',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'JOSE P. BRILLANTES',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'JOSE P. BRILLANTES SR. (OLD LITUBAN)',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'LATABON',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MAKIANG',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MALAMBUHANGIN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MALIPOT',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MANAOL',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MATEO FRANCISCO',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'MATIAG',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'NEW LITUBAN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'PANGIAN',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'PISAWAK',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'S. CABRAL',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'SIAY',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'SUHAILE ARABI',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'TABAYO',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'SIOCON',
        BARANGAY: 'TIBANGAO',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'BALATAKAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'BALONKAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'BALUBUAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'BITUGAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'BONGON',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'CATUYAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'CULASIAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'DANGANON',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'DONA CECILIA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'GUBAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'LAGUNDI',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'LIBUCON',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'LUBOK',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'MACUYON',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'MOTONG',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'NAPULAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PANABUTAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PIACAN',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PINA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PISA ITOM',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PISA PUTI',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PUGOS',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PULA BATO',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'PULANG LUPA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SAINT MARY (POB.)',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SIPAKIT',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SIPAWA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'SIRAWAI PROPER (POB.)',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'TALABIGA',
    },
    {
        CITY: 'SIRAWAI',
        BARANGAY: 'TAPANAYAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'BALACBAAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'BANBANAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'BARILI',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'CABONG',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'CAMUL',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'FARMINGTON',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'GALINGON',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'LAWAAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'LUMBAYAO',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'MALILA-T',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'MOLOS',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'NEW DAPITAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'POBLACION (TAMPILISAN)',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'SANDAYONG',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'SITUBO',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'TILUBOG',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'TININGGAAN',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'TAMPILISAN',
        BARANGAY: 'ZNAC',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'BALUBOHAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'BIRAYAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'DAMASING',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'EAST POBLACION',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'LA ESPERANZA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'MABUNAO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'MITIMOS',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'NANGCA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'NANGCAAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'NAPILAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'NASIPANG',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'NEW DAPITAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'NILABO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'NORTH MAPANG',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'RIZALINA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SEBACA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SIPAON',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SOUTH MAPANG',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'TOLON',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'WEST POBLACION',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'ALLANGIGAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'ANIOG',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BANIKET',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BARANGCUAG',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BAUI',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CALABAYAN-MINANGA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CALACCAB',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CAMPANARIO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CANANGAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CENTRO III (POB.)',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CONSULAR',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CUMU',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'DALAKIP',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'DALENAT',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'DIPALUDA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'DUROC',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'FUGARU',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'INGUD NORTE',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'INGUD SUR',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'KALUSUTAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'LA SUERTE',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'LIWLIWA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'LORIA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'LOURDES (EL ESCANO)',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MACALAUAT',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MACANIAO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MALANNAO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MANGANDINGAY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MINANGA PROPER',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'PAPPAT',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'PISSAY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'RAMONA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'RANCHO BASSIT',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'RANG-AYAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN AMBROCIO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN GUILLERMO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN MARCELO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SARANAY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SINABBARAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'VIGA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'VILLA DOMINGO',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'ANDABUEN',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'ARA',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'BALLIAO',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'BINOGTUNGAN',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'CAPUSERAN (CAPUROCAN)',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'DANIPA',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'GUILINGAN',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'LA SALETTE',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'LUCBAN',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'MAKINDOL',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'MALUNO NORTE',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'MALUNO SUR',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'NACALMA',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'NEW MAGSAYSAY',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'PLACER',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'PUNIT',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SEVILLANA',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SINIPIT',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'VILLALUZ',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'YEBAN NORTE',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'YEBAN SUR',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'AGGUB',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'ANAO',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'ANGANCASILIAN',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'BALASIG',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CANSAN',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CASIBARAG NORTE',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CASIBARAG SUR',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CATABAYUNGAN',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CUBAG',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'GARITA',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'LUQUILU',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'MABANGUG',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'MAGASSI',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'MASIPI EAST',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'MASIPI WEST',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'NGARAG',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'PILIG ABAJO',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'PILIG ALTO',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'SAN BERNARDO',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'SAUI',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'TALLAG',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'UGAD',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ALICAOCAO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ALINAM',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'AMOBOCAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ANDARAYAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BACULOD',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BARINGIN NORTE',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BARINGIN SUR',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BUENA SUERTE',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BUGALLON',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BUYON',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CARABATAN BACARENO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CARABATAN CHICA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CARABATAN GRANDE',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CARABATAN PUNTA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CASALATAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CASSAP FUERA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CATALINA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CULALABAT',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DABBURAB',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DE VERA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DIANAO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DISIMURAY',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DISTRICT III (POB.)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DUMINIT',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'FAUSTINO (SIPAY)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'GAGABUTAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'GAPPAL',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'GUAYABAL',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'LABINAB',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'LINGLINGAY',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MABANTAD',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MANAOAG',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MARABULIG I',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MARABULIG II',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MINANTE I',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MINANTE II',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'NAGANACAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'NAGCAMPEGAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'NAGRUMBUAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'NUNGNUNGAN I',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'NUNGNUNGAN II',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'PINOMA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ROGUS',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN FERMIN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN PABLO (CASAP HACIENDA)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SANTA LUCIANA (DABURAB 2)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SILLAWIT',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SINIPPIL',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'TAGARAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'TURAYONG',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'VILLA CONCEPCION',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'VILLA LUNA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'AGUINALDO (RIZALUNA ESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'ANONANG (BALITOC)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'ANONANG (BALITOC*)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'CALIMATUROD',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'CAMARAO',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'CAPIRPIRIWAN',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'CAQUILINGAN (SAN LUIS)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'DALLAO',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'GAYONG',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'LAUREL (CENTRO NORTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'MAGSAYSAY (CENTRO SUR OESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'MALAPAT',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'OSMENA (CENTRO SUR ESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'QUEZON (CENTRO NORTE ESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'QUIRINO (MANASIN)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'RIZALUNA (RIZALUNA OESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'ROXAS POB. (CENTRO SUR)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'SAGAT',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'SAN JUAN (SAN JUAN ESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'TALIKTIK',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'TANGGAL',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'TARINSING',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'TUROD NORTE',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'TUROD SUR',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'VILLAMARZO',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'VILLAMIEMBAN',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'WIGAN',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'AGA',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'ANDARAYAN',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'ANEG',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'BAYABO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'CALINAOAN SUR',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'CALOOCAN',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'CAPITOL',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'CARMENCITA',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'MAUI',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'QUIBAL',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'RAGAN ALMACEN',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'RAGAN NORTE',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'RAGAN SUR (POB.)',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'RIZAL (RAGAN ALMACEN ALTO)',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN MACARIO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN NICOLAS (FUSI)',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN PATRICIO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'VILLA LUZ',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'VILLA PEREDA',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'VISITACION',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'ANGOLUAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'ANNAFUNAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'ARABIAT',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'AROMIN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'BABARAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'BACRADAL',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'BENGUET',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'BUNEG',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'BUSILELAO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'CABUGAO (POB.)',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'CANIGUING',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'CARULAY',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'CASTILLO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'DAMMANG EAST',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'DAMMANG WEST',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'DIASAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'DICARAOYAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'DUGAYONG',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'GARIT NORTE',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'GARIT SUR',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'GUCAB',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'GUMBAUAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MABBAYAD',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MADADAMIAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MAGLETICIA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MALIBAGO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MALITAO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'NARRA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'NILUMISU',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'PANGAL NORTE',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'PANGAL SUR',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'RUMANG-AY',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN ANTONIO MINIT',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN ANTONIO UGAD',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN FABIAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN SALVADOR',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SILAUAN NORTE (POB.)',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SILAUAN SUR (POB.)',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SINABBARAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SOYUNG',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'TAGGAPPAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'TUGUEGARAO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'VILLA CAMPO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'VILLA FERMIN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'VILLA REY',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'VILLA VICTORIA',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'BARCOLAN',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'DAMMAO',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'DISTRICT III (POB.)',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'FURAO',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'GUIBANG',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'LENZON',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'LINGLINGAY',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'PINTOR',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'SONGSONG',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'UPI',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'AGGASIAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'ALIBAGU',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'ALLINGUIGAN 1ST',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'ALLINGUIGAN 2ND',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'ALLINGUIGAN 3RD',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'ARUSIP',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BACULOD (POB.)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BAGUMBAYAN (POB.)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BALIGATAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BALLACONG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BANGAG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BATONG-LABANG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BIGAO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABANNUNGAN 1ST',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABANNUNGAN 2ND',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 10 (LAPIGUI)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 14 AND 16 (CASILAGAN)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 17 AND 21 (SAN RAFAEL)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 19 (VILLA SUERTE)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 19 (VILLA SUERTE*)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 2 (DAPPAT)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 22 (SABLANG)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 23 (SAN FRANCISCO)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 23 (SAN FRANCISCO*)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 25 (STA. LUCIA)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 25 (STA. LUCIA*)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 27 (ABUAN)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 3 (SAN FERNANDO)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 4 (SAN MANUEL)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 5 (BARIBAD)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 6 & 24 (VILLA MARCOS)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 6 & 24 (VILLA MARCOS*)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 7 (NANGALISAN)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 9 AND 11 (CAPOGOTAN)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CADU',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CALAMAGUI 1ST',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CALAMAGUI 2ND',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CAMUNATAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CAPELLAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CAPO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CARIKKIKAN NORTE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CARIKKIKAN SUR',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CENTRO - SAN ANTONIO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CENTRO POBLACION',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'FUYO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'GAYONG-GAYONG NORTE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'GAYONG-GAYONG SUR',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'GUINATAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'IMELDA BLISS VILLAGE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'LULLUTAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MALALAM',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MALASIN (ANGELES)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MANARING',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MANGCURAM',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MARANA I',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MARANA II',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MARANA III',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MINABANG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MORADO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'NAGUILIAN NORTE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'NAGUILIAN SUR',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'NANAGUAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'OSMENA (SINIPPIL)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'PALIUEG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'PASA',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'QUIMALABASA',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'RANG-AYAN (BINTACAN)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'RUGAO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SALINDINGAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN ANDRES (ANGARILLA)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN IGNACIO (CANAPI)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN RODRIGO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA BARBARA (POB.)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA ISABEL NORTE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA ISABEL SUR',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA MARIA (CABESERIA 8)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA VICTORIA',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SIFFU',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SINDON BAYABO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SINDON MARIDE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SIPAY',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'TANGCUL',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'VILLA IMELDA (MAPLAS)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'AMISTAD',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'ANTONINO (POB.)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'APANAY',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BAGNOS',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BANTUG-PETINES',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'CALAOCAN (POB.)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'CALLAO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'INANAMA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'LINGLINGAY',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'M.H. DEL PILAR',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'MAGSAYSAY (POB.)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'MATAAS NA KAHOY',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'PADDAD',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'RIZALUNA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'APIAT',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BAGNOS',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BAGONG TANZA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BALLESTEROS',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BANNAGAO',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BOLINAO',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'CAIPILAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'CAMARUNGGAYAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'DALIG-KALINGA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'DIAMANTINA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'ESPERANZA EAST',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'ESPERANZA WEST',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'KALABAZA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'MACATAL',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'NAMPICUAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'PANECIEN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'RIZALUNA (LAPUZ)',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN PEDRO-SAN PABLO (POB.)',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SARANAY',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SILI',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'VILLA FUGU',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'VILLA NUESA',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'BACNOR EAST',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'BACNOR WEST',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'CALIGUIAN (POB.)',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'CATABBAN',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'CULLALABO DEL NORTE',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'CULLALABO DEL SUR',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'CULLALABO SAN ANTONIO',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'DALIG',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'MASIGUN',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'RANIAG',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'SAN BONIFACIO',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CANAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CULING CENTRO',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CULING EAST',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CULING WEST',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'DEL CORPUZ',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'DIAMANTINA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'LUZON',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'MACALAOAT',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'MAGDALENA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'NUEVA ERA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'RANG-AY (CAGGONG)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'SAN ANDRES (TEODORO ABAD)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'SARANAY',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TANDUL',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'BUSTAMANTE',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CENTRO 1 (POB.)',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CENTRO 2 (POB.)',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CENTRO 3 (POB.)',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'DADAP',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'HARANA',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'LALOG 1',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'LALOG 2',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'LUYAO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'MACANAO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'MACUGAY',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'MAMBABANGA',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'PULAY',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'PUROC',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'UNION KALINGA',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'FLORES',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MAGSAYSAY (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MANARING',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MANSIBANG',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MINALLO',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'PALATTAO',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'QUEZON (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'QUINALABASA',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'QUIRINO (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'RANGAYAN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'ROXAS (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SANTA VICTORIA (VILLA CAPUCHINO)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SUNLIFE',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SURCOC',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'TOMINES',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'VILLA PAZ',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ABUT',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ALUNAN (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ARELLANO (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BARUCBOC NORTE',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CALANGIGAN (CALAMAGUI)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DUNMON',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ESTRADA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'LEPANTO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MANGGA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MINAGBAG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAMONTE (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SANTOS (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TUROD',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'BINARZANG',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'CAMAAL',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'MANAOAG',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SANTA LUCIA (POB.)',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SINAIT',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SUERTE',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'VILLA BULUSAN',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'VILLA MIGUEL (UGAK)',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'VINTAR',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'ANAO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BANTUG (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'DONA CONCHA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'IMBIAO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LANTING',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LUCBAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LUNA (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MARCOS',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MASIGUN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MATUSALEM',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MUNOZ EAST',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MUNOZ WEST',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'QUILING',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'RANG-AYAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN PLACIDO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SIMIMBAAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SINAMAR',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SOTERO NUESA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'VILLA CONCEPCION',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'VIRA (POB.)',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'BAUTISTA',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'DABUBU GRANDE',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'DABUBU PEQUENO',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'DAPPIG',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'LAOAG',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'MAPALAD',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'MASAYA CENTRO (POB.)',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'MASAYA NORTE',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'MASAYA SUR',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'NEMMATAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'PALACIAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'PANANG',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'QUIMALABASA NORTE',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'QUIMALABASA SUR',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'RANG-AY',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SANTOS',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SINAOANGAN NORTE',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SINAOANGAN SUR',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'VIRGONEZA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CAMARAG',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CEBU',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'GUD',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'NAGBUKEL',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'PATANAD',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'RAMOS EAST',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'RAMOS WEST',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'RIZAL EAST (POB.)',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'RIZAL WEST (POB.)',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'AGLIAM',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'BABANUANG',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'CABARITAN',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'CARANIOGAN',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'DISTRICT 1 (POB.)',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'DISTRICT 2 (POB.)',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'DISTRICT 3 (POB.)',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'DISTRICT 4 (POB.)',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'EDEN',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'MALALINTA',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'MARARIGUE',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'NUEVA ERA',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'PISANG',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SANDIAT CENTRO',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SANDIAT EAST',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SANDIAT WEST',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'VILLANUEVA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BACARENA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BELLA LUZ',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'DARAMUANGAN NORTE',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'DARAMUANGAN SUR',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'GADDANAN',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'MARASAT GRANDE',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'MARASAT PEQUENO',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'OLD CENTRO I',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'OLD CENTRO II',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SALINUNGAN EAST',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SALINUNGAN WEST',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN IGNACIO',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SINAMAR NORTE',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SINAMAR SUR',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'VILLA CRUZ',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'VILLA GAMIAO (BUYON)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'VILLA MAGAT',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'VILLAFUERTE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'ANNANUMAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'AUITAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BALLACAYU',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BINGUANG',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BUNGAD',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'CADDANGAN/LIMBAUAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'CALAMAGUI',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'CARALUCUD',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'DALENA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'GUMINGA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'MINANGA NORTE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'MINANGA SUR',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SIMANU NORTE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SIMANU SUR',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'TUPA (SAN VICENTE)',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BANGAD',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CALAMAGUI EAST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CALAMAGUI NORTH',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CALAMAGUI WEST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'LINGALING',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MOZZOZZIN NORTH',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MOZZOZZIN SUR',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'NAGANACAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'QUINAGABIAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN ISIDRO EAST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN ISIDRO WEST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN RAFAEL EAST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN RAFAEL WEST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'VILLABUENA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'AMMUGAUAN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'ANTAGAN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BAGABAG',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BAGUTARI',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BALELLENG',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BARUMBONG',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BIGA OCCIDENTAL',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BIGA ORIENTAL',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BOLINAO-CULALABO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BUBUG',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CALANIGAN NORTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CALANIGAN SUR',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CALINAOAN CENTRO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CALINAOAN MALASIN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CALINAOAN NORTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CANOGAN ABAJO NORTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CANOGAN ABAJO SUR',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CANOGAN ALTO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CENTRO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'COLUNGUAN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'MALAPAGAY',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN RAFAEL ABAJO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN RAFAEL ALTO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'UAUANG-GALICIA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'UAUANG-TULIAO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'ABULAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'ADDALAM',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'ARUBUB',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'BARANGCUAG',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DALIBUBON',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DALIGAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DIARAO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DIBULUAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DICAMAY I',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DICAMAY II',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DIPANGIT',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DISIMPIT',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DIVINAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DUMAWING',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'LACAB',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'LINAMANAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'LINOMOT',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'MALANNIT',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'MINURI',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'NAPALIONG',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'PALAGAO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'PAPAN ESTE',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'PAPAN WESTE',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'PAYAC',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'PONGPONGAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'TUPAX',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'USOL',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'VILLA BELLO',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'BINMONTON',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'CASILI',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'HOLY FRIDAY',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'MANANO',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'OLANGO',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'RANG-AYAN',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SAN JOSE NORTE I',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SAN JOSE NORTE II',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SAN JOSE SUR',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SAN PEDRO (BARUCBUC SUR)',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SIEMPRE VIVA NORTE',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SIEMPRE VIVA SUR',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'TRINIDAD',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'AMBATALI',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'BUGALLON NORTE',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'BUGALLON PROPER (POB.)',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'GENERAL AGUINALDO',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'NAGBACALAN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'OSCARIZ',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'PABIL',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'PAGRANG-AYAN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'PLANAS',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'PUROK NI BULAN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'RANIAG',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'VILLA BELTRAN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'VILLA CARMEN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'VILLA MARCOS',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'BANQUERO',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'BINARSANG',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'CUTOG GRANDE',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'CUTOG PEQUENO',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'DANGAN',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'LABINAB GRANDE (POB.)',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'LABINAB PEQUENO (POB.)',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'MALLALATANG GRANDE',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'MALLALATANG TUNGGUI',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'NAPACCU GRANDE',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'NAPACCU PEQUENO',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'SALUCONG',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'SINIPPIL',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'TALLUNGAN (POB.)',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'TUROD',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'VILLADOR',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'ARINGAY',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'CALAOAGAN',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'CENTRO 1 (POB.)',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'CENTRO 2 (POB.)',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'COLORADO',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'DIETBAN',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'DINGADING',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'DIPACAMO',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'GUAM',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'NAKAR',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'PALAWAN',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'PROGRESO',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SAN FRANCISCO NORTE',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SAN FRANCISCO SUR',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SAN MARIANO NORTE',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SAN MARIANO SUR',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SINALUGAN',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'VILLA REMEDIOS',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'VILLA ROSE',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'VILLA SANCHEZ',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'VILLA TERESITA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'ALIBADABAD',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'BALAGAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'BINATUG',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'BITABIAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'BUYASAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'CADSALAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'CASALA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'CATAGUING',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DARAGUTAN EAST',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DARAGUTAN WEST',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DIBULUAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DICAMAY',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DIPUSU',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DISULAP',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DISUSUAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'GANGALAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'IBUJAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'MACAYUCAYU',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'MALLABO',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'MARANNAO',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'OLD SAN MARIANO',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'PALUTAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'PANNINAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'SANTA FILOMINA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'TAPPA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'UEG',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'ABRA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'AMBALATUNGAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BALINTOCATOC',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BALUARTE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BANNAWAG NORTE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BATAL',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CABULAY',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CALAO EAST (POB.)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CALAO WEST (POB.)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CENTRO EAST (POB.)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CENTRO WEST (POB.)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'DUBINAN EAST',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'DUBINAN WEST',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'MALVAR',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'NABBUAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'NAGGASICAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'PATUL',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAGANA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SALVADOR',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SINILI',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SINSAYON',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'VICTORY NORTE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'VICTORY SUR',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'VILLA GONZAGA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'VILLASIS',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'ANNAFUNAN',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'ANTAGAN I',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'ANTAGAN II',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'ARCON',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BALUG',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BANIG',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BARANGAY DISTRICT 1 (POB.)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BARANGAY DISTRICT 2 (POB.)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BARANGAY DISTRICT 3 (POB.)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BARANGAY DISTRICT 4 (POB.)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BAYABO EAST',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'CALIGAYAN',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'CAMASI',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'CARPENTERO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'COMPANIA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'CUMABAO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'FERMELDY (HCDA. SAN FRANCISCO)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'FUGU ABAJO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'FUGU NORTE',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'FUGU SUR',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'LALAUANAN',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'LANNA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'LAPOGAN',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'LINGALING',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'LIWANAG',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'MALAMAG EAST',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'MALAMAG WEST',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'MOLDERO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'PARAGU',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'PILITAN',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SANTA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SANTA VISITACION (MAGGAYU)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SINIPPIL',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SISIM ABAJO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SISIM ALTO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'TUNGGUI',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'UGAD',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'BAKING',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'BALUKBAHAN',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'BALUMBUNAN',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'BANTAL',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'BOBUAN',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'CAMP BLESSING',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'CANOAYAN',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'CONACON',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'DAGUM',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'DAMIT',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'DEPASE',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'DEPILI',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'DEPORE',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'DEPOREHAN',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'DIMALINAO',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'KAHAYAGAN',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'KANIPAAN',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'LAMARE',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'LIBA',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'MATIN-AO',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'MATUN-OG',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'PANGI (SAN ISIDRO)',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'PULANG BATO',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'SALAWAGAN',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'SIGACAD',
    },
    {
        CITY: 'BAYOG',
        BARANGAY: 'SUPON',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'BACAYAWAN',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'BAHA',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'BALANAGAN',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'BALUNO',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'BINUAY',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'BUBURAY',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'GRAP',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'JOSEFINA',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'KAGAWASAN',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'LALAB',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'MAGAHIS',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'SALOAGAN',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'SUGBAY UNO',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'SUMBATO',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'SUMPOT',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'TINGGABULONG',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'TINIGUANGAN',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'TIPANGI',
    },
    {
        CITY: 'DIMATALING',
        BARANGAY: 'UPPER LUDIONG',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'BACAWAN',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'BENUATAN',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'BERAY',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'DON JOSE',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'DONGOS',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'EAST MIGPULAO',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'GUINICOLALAY',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'IGNACIO GARRATA (NEW MIRAPAO)',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'KINACAP',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'LEGARDA 1',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'LEGARDA 2',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'LEGARDA 3',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'LOWER DIMAYA',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'LUCOBAN',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'LUDIONG',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'NIAN',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'OLD MIRAPAO',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'PISA-AN',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'PROPER DIMAYA',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'SAGACAD',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'SAMBULAWAN',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'SONGAYAN',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'SUMPOTAN',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'TARAKAN',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'UPPER DIMAYA',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'UPPER SIBUL',
    },
    {
        CITY: 'DINAS',
        BARANGAY: 'WEST MIGPULAO',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'BAGA',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'BAG-ONG MISAMIS',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'BAG-ONG SILAO',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'BALOBOAN',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'BANTA-AO',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'BIBILIK',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'CALINGAYAN',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'CAMALIG',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'CAMANGA',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'CUATRO-CUATRO',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'LOCUBAN',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'MALASIK',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'MAMA (SAN JUAN)',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'MATAB-ANG',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'MECOLONG',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'METOKONG',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'MOTOSAWA',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'PAG-ASA (POB.)',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'PAGLAUM (POB.)',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'PANTAD',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'PINIGLIBANO',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'REBOKON',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'SIBUCAO',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'SUMADAT',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'TIKWAS',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'TINA',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'TUBO-PAIT',
    },
    {
        CITY: 'DUMALINAO',
        BARANGAY: 'UPPER DUMALINAO',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'BAGONG KAUSWAGAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'BAG-ONG VALENCIA',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'BUCAYAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'CALUMANGGI',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'CANIBONGAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'DANLUGAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'DAPIWAK',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'DATU TOTOCAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'DILUD',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'DITULAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'DULIAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'DULOP',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'GUINTANANAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'GUITRAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'GUMPINGAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'LA FORTUNA',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'LABANGON',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'LICABANG',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'LIPAWAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'LOWER LANDING',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'LOWER TIMONAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'MACASING',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'MALAGALAD',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'MANLABAY',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'MARALAG',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'MARANGAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'NEW BASAK',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'SAAD',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'SALVADOR',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'SAN PABLO (POB.)',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'SENOTE',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'SINONOK',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'SUNOP',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'TAGUN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'TAMURAYAN',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'UPPER LANDING',
    },
    {
        CITY: 'DUMINGAG',
        BARANGAY: 'UPPER TIMONAN',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'BAGONG OROQUIETA',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'BAGUITAN',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'BALONGATING',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'CANUNAN',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'DACSOL',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'DAGOHOY',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'DALAPANG',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'GULING',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'LINTUM',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'LITAN',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'MAGTING',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'POBLACION (GUIPOS)',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'REGLA',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'SIKATUNA',
    },
    {
        CITY: 'GUIPOS',
        BARANGAY: 'SINGCLOT',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'BOGO CALABAT',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'DAWA (DIWA)',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'EBARLE',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'GUMAHAN (POB.)',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'LEONARDO',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'LITAPAN',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'LOWER BAGONG TUDELA',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'MANSANAS',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'MORADJI',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'NEMENO',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'NOPULAN',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'SEBUKANG',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'TAGAYTAY HILL',
    },
    {
        CITY: 'JOSEFINA',
        BARANGAY: 'UPPER BAGONG TUDELA (POB.)',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'BOGAYO',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'BOLISONG',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'BOYUGAN EAST',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'BOYUGAN WEST',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'DIPLO',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'GAWIL',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'GUSOM',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'KITAAN DAGAT',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'LANTAWAN',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'LIMAMAWAN',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'PICANAN',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'SALAGMANOK',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'SECADE',
    },
    {
        CITY: 'KUMALARANG',
        BARANGAY: 'SUMINALUM',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'BAGALUPA',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'BALIMBINGAN (WEST LUYA)',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'BINAYAN',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'BOKONG',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'BULANIT',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'COGONAN',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'COMBO',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'DALAPANG',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'DIMASANGCA',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'DIPAYA',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'LANGAPOD',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'LANTIAN',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'LOWER CAMPO ISLAM (POB.)',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'LOWER PULACAN',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'LOWER SANG-AN',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'NEW LABANGAN',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'NOBORAN',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'OLD LABANGAN',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'TAPODOC',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'TAWAGAN NORTE',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'UPPER CAMPO ISLAM (POB.)',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'UPPER PULACAN',
    },
    {
        CITY: 'LABANGAN',
        BARANGAY: 'UPPER SANG-AN',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'BAGONG KAHAYAG',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'BAKING',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'BISWANGAN',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'BULULAWAN',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'DAGUM',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'GASA',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'GATUB',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'LUKUAN',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'MATALANG',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'POBLACION (LAKEWOOD)',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'SAPANG PINOLES',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'SEBUGUEY',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'TIWALES',
    },
    {
        CITY: 'LAKEWOOD',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'CARPOC',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'DANGANAN',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'DANSAL',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'DUMARA',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'LINOKMADALUM',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'LUANAN',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'LUBUSAN',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'MAHALINGEB',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'MANDEG',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'MARALAG',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'MARUING',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'MOLUM',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'PAMPANG',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'PANTAD',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'PINGALAY',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'SALAMBUYAN',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'SAYOG',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'TALABAB',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'TIGUHA',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'TININGHALANG',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'TIPASAN',
    },
    {
        CITY: 'LAPUYAN',
        BARANGAY: 'TUGAYA',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'BAG-ONG BALAMBAN',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'BAG-ONG DALAGUETE',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'BONIAO',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'DELUSOM',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'DIWAN',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'GURIPAN',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'KAANGAYAN',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'KABUHI',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'LOURMAH (LOWER MAHAYAG)',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'LOWER SALUG DAKU',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'LOWER SANTO NINO',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'LOWER SANTO NIÑO',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'MALUBO',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'MANGUILES',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'MARABANAN (BALANAN)',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'PANAGAAN',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'PEDAGAN',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'POBLACION (UPPER MAHAYAG)',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'PUGWAN',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'SICPAO',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'TUBORAN',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'TULAN',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'TUMAPIC',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'UPPER SALUG DAKU',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'UPPER SANTO NINO',
    },
    {
        CITY: 'MAHAYAG',
        BARANGAY: 'UPPER SANTO NIÑO',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'BALINTAWAK',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'BULARONG',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'DIGON',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'GUINIMANAN',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'IGAT ISLAND',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'JOSEFINA',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'KALIAN',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'KOLOT',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'LIMABATONG',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'LIMAMAWAN',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'LUMBOG',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'MAGAHIS',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'SAGUA',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'TALANUSA',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'TIGUIAN',
    },
    {
        CITY: 'MARGOSATUBIG',
        BARANGAY: 'TULAPOC',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'BACAHAN',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'BALONAI',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'BIBILOP',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'BULORON',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'CABALORAN',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'CANIPAY NORTE',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'CANIPAY SUR',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'CUMARON',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'DAKAYAKAN',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'DUELIC',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'DUMALINAO',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'ECUAN',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'GOLICTOP',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'GUINABOT',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'GUITALOS',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'GUMA',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'KAHAYAGAN',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'LICURO-AN',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'LUMPUNID',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'MATALANG',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'NEW KATIPUNAN',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'NEW UNIDOS',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'PALILI',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'PAWAN',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'PISOMPONGAN',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'PIWAN',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'POBLACION A',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'POBLACION B',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'SIGAPOD',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'TIMBABOY',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'TULBONG',
    },
    {
        CITY: 'MIDSALIP',
        BARANGAY: 'TULUAN',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'ALICIA',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'ARIOSA',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'BAGONG ARGAO',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'BAGONG GUTLANG',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'BLANCIA',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'BOGO CAPALARAN',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'CULO',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'DALAON',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'DIPOLO',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'DONTULAN',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'GONOSAN',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'LOWER DIMALINAO',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'LOWER DIMOROK',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'MADASIGON (POB.)',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'MAKUGUIHON (POB.)',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'MALOLOY-ON (POB.)',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'MILIGAN',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'PARASAN',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'SILANGIT',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'SIMATA',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'SUDLON',
    },
    {
        CITY: 'MOLAVE',
        BARANGAY: 'UPPER DIMOROK',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'BALANGASAN (POB.)',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'BALINTAWAK',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'BALOYBOAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'BANALE',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'BOGO',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'BOMBA',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'BULATOK',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'DAMPALAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'DANLUGAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'DEBOROK',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'DITORAY',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'DUMAGOC',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'GATAS (POB.)',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'GUBAC',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'GUBANG',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'KAGAWASAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'KAHAYAGAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'KALASAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'KAWIT',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'LA SUERTE',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'LALA',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'LAPIDIAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'LENIENZA',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'LIZON VALLEY',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'LOWER SIBATANG',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'LUMAD',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'LUMBIA',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'MACASING',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'MURICAY',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'NAPOLAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'PALPALAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'PEDULONAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'POLOYAGAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'SANTA LUCIA (POB.)',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'SANTIAGO (POB.)',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'TAWAGAN SUR',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'TIGUMA',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'TUBURAN (POB.)',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'TULANGAN',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'TULAWAS',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'UPPER SIBATANG',
    },
    {
        CITY: 'PAGADIAN',
        BARANGAY: 'WHITE BEACH',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'BAGONG OPON',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'BAMBONG DAKU',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'BAMBONG DIUT',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'BOBONGAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'CAMPO IV',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'CAMPO V',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'CANIANGAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'DIPALUSAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'EASTERN BOBONGAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'GAPASAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'LOWER SAMBULAWAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'MALATING',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'PARADISE',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'PASINGKALAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'SAPA ANDING',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'SINAGUING',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'SWITCH',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'UPPER LAPERIAN',
    },
    {
        CITY: 'RAMON-MAGSAYSAY',
        BARANGAY: 'WAKAT',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'BAG-ONG BAROY',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'BAG-ONG OROQUIETA',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'BARUBUHAN',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'BULANAY',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'EASTERN POBLACION',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'LANTAWAN',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'LUMANGOY',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'NEW CARMEN',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'PICTURAN',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'SAWA',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'TUNGAWAN',
    },
    {
        CITY: 'SOMINOT',
        BARANGAY: 'UPPER SICPAO',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'ABONG-ABONG',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'BAGANIAN',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'BAYA-BAYA',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'CAPISAN',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'CULABAY',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'DONA JOSEFINA',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'LUMBIA',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'MALIM',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'MANIKAAN',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'NEW OROQUIETA',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'TABINA',
        BARANGAY: 'TULTOLAN',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'ALANG-ALANG',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'ANGELES',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'BAG-ONG KAUSWAGAN',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'BAG-ONG TABOGON',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'BALUGO',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'CABGAN',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'CALOLOT',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'DIMALINAO',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'FABIAN (BALUCOT)',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'GABUNON',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'HAPPY VALLEY (POB.)',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'KAPALARAN',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'LIBATO',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'LIMAMAWAN',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'LOWER LIASAN',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'LOWER LODIONG (POB.)',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'LOWER TIPARAK',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'LOWER USOGAN',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'MAYA-MAYA',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'NEW VILLAGE (POB.)',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'PELOCOBAN',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'RIVERSIDE (POB.)',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'SAGRADA FAMILIA',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'SUMALIG',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'TULUAN',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'TUNGAWAN',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'UPPER LIASON',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'UPPER LODIONG',
    },
    {
        CITY: 'TAMBULIG',
        BARANGAY: 'UPPER TIPARAK',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'BEGONG',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'BUSOL',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'CALUMA',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'DIANA COUNTRYSIDE',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'GUINLIN',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'LACARAYAN',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'LACUPAYAN',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'LIBAYOY',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'LIMAS',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'LONGMOT',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'MARAGANG',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'MATE',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'NANGAN-NANGAN',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'NEW TUBURAN',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'NILO',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'TIMOLAN',
    },
    {
        CITY: 'TIGBAO',
        BARANGAY: 'UPPER NILO',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'ALINDAHAW',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'BACLAY',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'BALIMBINGAN',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'CAMANGA',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'CURVADA',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'LAPERIAN',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'LOWER BAYAO',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'LUY-A',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'MANILAN',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'MANLAYAG',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'MILITAR',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'NAVALAN',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'PANDUMA SENIOR',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'SAMBULAWAN',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'SAN CARLOS (POB.)',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'TABUAN',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'TAGULO',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'TINOTUNGAN',
    },
    {
        CITY: 'TUKURAN',
        BARANGAY: 'UPPER BAYAO',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'AMBULON',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'BUI-OS',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'DANAN',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'KABATAN',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'KAPATAGAN',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'LIMASON',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'LINOGUAYAN',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'LUMBAL',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'LUNIB',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'MACULAY',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'MARAYA',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'SAGUCAN',
    },
    {
        CITY: 'VINCENZO-A.-SAGUN',
        BARANGAY: 'WALING-WALING',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'ARENA BLANCO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'AYALA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BALIWASAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BALUNO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BARANGAY ZONE I (POB.)',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BARANGAY ZONE II (POB.)',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BARANGAY ZONE III (POB.)',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BARANGAY ZONE IV (POB.)',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BOALAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BOLONG',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BUNGUIAO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'BUSAY (SACOL ISLAND)',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CABALUAY',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CABATANGAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CACAO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CALABASA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CALARIAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CAMINO NUEVO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CAMPO ISLAM',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CANELAR',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CAPISAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CAWIT',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CULIANAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'CURUAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'DITA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'DULIAN (UPPER BUNGUIAO)',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'DULIAN (UPPER PASONANCA)',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'GUISAO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'GUIWAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'KASANYANGAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LABUAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LAMISAHAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LANDANG GUA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LANDANG LAUM',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LANZONES',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LAPAKAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LATUAN (CURUAN)',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LICOMO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LIMAONG',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LIMPAPA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LOWER CALARIAN BAGONG CALARIAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LOWER CALARIAN SOUTHCOM',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LOWER CALARIAN WESTMINCOM',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LUBIGAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LUMAYANG',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LUMBANGAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'LUNZURAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'MALAGUTAY',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'MAMPANG',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'MANALIPA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'MANGUSU',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'MANICAHAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'MARIKI',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'MUTI',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'PAMUCUTAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'PANGAPUYAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'PANUBIGAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'PASILMANTA (SACOL ISLAND)',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'PASOBOLONG',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'PASONANCA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'PATALON',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'PUTIK',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'QUINIPUT',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'RECODO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'RIO HONDO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SALAAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SAN JOSE CAWA-CAWA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SAN JOSE GUSU',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SAN JOSE GUSU SUTERVILE',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SANGALI',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SIBULAO (CARUAN)',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SINUBUNG',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'SINUNOC',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TABUK J.JOHNSTON STREET',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TAGASILAY',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TAGUITI',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TALABAAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TALISAYAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TALON-TALON',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TALUKSANGAY',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TETUAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TICTAPUL',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TIGBALABAG',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TIGTABON',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TOLOSA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TUGBUNGAN',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TULUNGATUNG',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TULUNGATUNG',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TUMAGA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TUMALUTAB',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'TUMITUS',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'VITALI',
    },
    {
        CITY: 'ZAMBOANGA',
        BARANGAY: 'ZAMBOWOOD',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'ACAD',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'ALANG-ALANG',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BAGONG MANDAUE',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BAGONG MASLOG',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BAGONG OSLOB',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BAGONG PITOGO',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BAKI',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BALAS',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BALIDE',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BALINTAWAK',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BEMPOSA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'CABILINAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'CAMPO UNO',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'CEBONEG',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'COMMONWEALTH',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'GUBAAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'INASAGAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'INROAD',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'KAHAYAGAN EAST (KATIPUNAN)',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'KAHAYAGAN WEST',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'LA PAZ (TINIBTIBAN)',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'LA VICTORIA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'LANTUNGAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'LINTUGOP',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'LUBID',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'MAGUIKAY',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'MONTE ALEGRE',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'MONTELA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'PANAGHIUSA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'RESTHOUSE',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'ROMARATE',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAPA LOBOC',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'TAGULALO',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'WATERFALL',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'BALABAWAN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'BALONG-BALONG',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'COLOJO',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'LIASAN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'LIGUAC',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'LIMBAYAN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'LOWER PANIKI-AN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'MATIN-AO',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'PANUBIGAN',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'POBLACION (PITOGO)',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'PUNTA FLECHA',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'SUGBAY DOS',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'TONGAO',
    },
    {
        CITY: 'PITOGO',
        BARANGAY: 'UPPER PANIKI-AN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BETINAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CALUBE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'DAO-AN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'DUMALIAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LANGILAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LANTAWAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LAPERIAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LIBUGANAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LIMONAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MATI',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'OCAPAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAYOG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'TAPIAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BAG-ONG MISAMIS',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BUBUAL',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BUTON',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'CULASIAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'DAPLAYAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'KALILANGAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'KAPAMANOK',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'KONDUM',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'LUMBAYAO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'MARCOS VILLAGE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'MIASIN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'MOLANSONG',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'PANTAD',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'PAO',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'PAYAG',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'POBLACION (SAN PABLO)',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'PONGAPONG',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SACBULAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAGASAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SENIOR',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SONGGOY',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'TANDUBUAY',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'TANIAPAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'TICALA ISLAND',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'TUBO-PAIT',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'VILLAKAPA',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'AGUTAYAN',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'BAGONG BORBON',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'BASALEM',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'BAWANG',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'BLISS',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'BULAAN',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'COMPOSTELA',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'DANLUGAN',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'DATU PANAS',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'DEL MONTE',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'GUINTULOAN',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'GUITOM',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'GUMINTA',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'LABRADOR',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'LANTAWAN',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'MAGANAY',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'MANLIN',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'MUYO',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'PAMINTAYAN',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'PLING',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'PULOG',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'TALAIRAN',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'TALAMIMI',
    },
    {
        CITY: 'BUUG',
        BARANGAY: 'VILLACASTOR (GALIT)',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'BALANGAO',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'BUTONG',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'DITAY',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'GAULAN',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'GOLING',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'GUINOMAN',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'LINDANG',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'LOBING',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'LUOP',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'MANANGON',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'MEJO',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'NATAN',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'NATAN',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'PARADISE',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'POBLACION (DIPLAHAN)',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'SAMPOLI A',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'SAMPOLI B',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'SONGCUYA',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'TINONGTONGAN',
    },
    {
        CITY: 'DIPLAHAN',
        BARANGAY: 'TUNO',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'BALUGO',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'BALUNGISAN',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'BALUYAN',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'CANA-AN',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'DUMPOC',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'GANDIANGAN',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'ISRAEL (BALIAN ISRAEL)',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'LA VICTORIA',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'LITTLE BAGUIO',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'LOWER BALURAN',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'LUMBOG',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'LUMPANAC',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'MALI LITTLE BAGUIO',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'POBLACION (SANTA FE)',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'PULAWAN (MT. VIEW)',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'IMELDA',
        BARANGAY: 'UPPER BALURAN',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'BACALAN',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'BANGKEROHAN',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'BULU-AN',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'CAPARAN',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'DOMANDAN',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'DON ANDRES',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'DONA JOSEFA',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'GUITUAN',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'IPIL HEIGHTS',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'LABI',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'LOGAN',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'LOWER IPIL HEIGHTS',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'LOWER TAWAY',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'LUMBIA',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'MAGDAUP',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'MAKILAS',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'SANITO',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'SUCLEMA',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'TAWAY',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'TENAN',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'TIAYON',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'TIMALANG',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'TOMITOM',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'UPPER PANGI',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'VETERANS VILLAGE (RUIZ)',
    },
    {
        CITY: 'IPIL',
        BARANGAY: 'VETERAN\'S VILLAGE(RUIZ)',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'BANKER',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'BOLO BATALLION',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'BUAYAN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'CAINGLET',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'CALAPAN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'CALUBIHAN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'CONCEPCION (BALUNGIS)',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'DIAMPAK',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'DIPALA',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'GACBUSAN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'GOODYEAR',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'LACNAPAN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'LITTLE BAGUIO',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'LUMBAYAO',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'NAZARETH',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'PALINTA',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'PENARANDA',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'RIVERSIDE',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'SANGHANAN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'SAYAO',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'SHIOLAN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'SIMBOL',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'SININAN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'TAMIN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'TAMPILISAN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'TIGBANGAGAN',
    },
    {
        CITY: 'KABASALAN',
        BARANGAY: 'TIMUAY DANDA (MANGAHAS)',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'ABUNDA',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'BANGKAW-BANGKAW',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'CALIRAN',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'CATIPAN',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'LOOC-BARLAK',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'PAMANSAAN',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'PINALIM (SAN ROQUE)',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'PUNAWAN',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'SANTO NINO (CALIRAN)',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'SAWA',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'SIOTON',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'TAGUISIAN',
    },
    {
        CITY: 'MABUHAY',
        BARANGAY: 'TANDU-COMOT (KATIPUNAN)',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'BACAO',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'BASAK-BAWANG',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'BONTONG',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'CAMANGA',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'CANDIIS',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'CATITUAN',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'DANSULAO',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'GUILAWA',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'KIGAY',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'LA DICHA',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'LIPACAN',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'LOGPOND',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'MALUNGON',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'MULOM',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'OVERLAND',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'PALALIAN',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'PAYAG',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'REBOCON',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'SINUSAYAN',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'TACKLING',
    },
    {
        CITY: 'MALANGAS',
        BARANGAY: 'TIGABON',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'BAGA',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'BALUNO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'BANGKAW-BANGKAW',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'CABONG',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'CROSSING STA. CLARA',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'GUBAWANG',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'GUINTOLOAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'KALIANTANA',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'LOWER SULITAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'MAMAGON',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'MARSOLO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'SANDAYONG',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'SULO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TAMBANAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TAYTAY MANUBO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TILUBOG',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TIPAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'UPPER SULITAN',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'BATERIA',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'CALAIS (KALINES)',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'FAMA',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'GALAS',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'GANDAAN',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'KAHAYAGAN',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'LOOC SAPI',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'MATIM',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'NOQUE',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'PULO LAUM',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'PULO MABAO',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'SOLAR (POB.)',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'TAMBANAN',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'VILLACORTE',
    },
    {
        CITY: 'OLUTANGA',
        BARANGAY: 'VILLAGONZALO',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'BALIAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'BALUNGISAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'BINANGONAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'BULACAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'CALAPE',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'DALAMA',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'FATIMA (SILAL)',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'GUINTOLAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'GUIWAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'KIMA',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'KULASIAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'KULISAP',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'LA FORTUNA',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'LABATAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'MAYABO (SANTA MARIA)',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'MINUNDAS (SANTO. NINO)',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'MINUNDAS (SANTO. NIÑO)',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'MOUNTAIN VIEW (PULUAN)',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'NANAN',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'POBLACION (PAYAO)',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'SAN VICENTE (BINANGONAN)',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'SILAL',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'SUMILONG',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'TALAPTAP',
    },
    {
        CITY: 'PAYAO',
        BARANGAY: 'UPPER SUMILONG',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'ALI ALSREE',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'BALANSAG',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'CALULA',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'CASACON',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'DON PERFECTO',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'GANGO',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'KULAMBUGAN',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'MALUBAL',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'NEW ANTIQUE',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'NEW SAGAY',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'PALMERA',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'PRES. ROXAS',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'REMEDIOS',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'SAN FERNANDINO',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'SIAWANG',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'SILINGAN',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'SURABAY',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'TARUC',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'TILASAN',
    },
    {
        CITY: 'ROSELLER-LIM',
        BARANGAY: 'TUPILAC',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'BALAGON',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'BALINGASAN',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'BALUCANAN',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'BATAAN',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'BATU',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'BUYOGAN',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'CAMANGA',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'COLORAN',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'KIMOS (KIMA)',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'LABASAN',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'LAGTING',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'LAIH',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'LOGPOND',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'MANIHA',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'MINSULAO',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'MIRANGAN',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'MONCHING',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'PARUK',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'PRINCESA SUMAMA',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'SALINDING',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'SIBUGUEY',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'SILOH',
    },
    {
        CITY: 'SIAY',
        BARANGAY: 'VILLAGRACIA',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'BAGANIPAY',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'BOLINGAN',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'BUALAN',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'CAWILAN',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'FLORIDA',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'KASIGPITAN',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'LAPARAY',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'MOALBOAL',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'POBLACION (TALUSAN)',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'SAGAY',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'SAMONTE',
    },
    {
        CITY: 'TALUSAN',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'ACHASOL',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'AZUSANO',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'BANGCO',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'CAMANGA',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'CULASIAN',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'DALANGIN',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'DALANGIN MUSLIM',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'DALISAY',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'GOMOTOC',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'IMELDA (UPPER CAMANGA)',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'KIPIT',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'KITABOG',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'LA LIBERTAD',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'LONGILOG',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'MALAGANDIS',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'MATE',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'MOALBOAL',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'NEW CANAAN',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'PALOMOC',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'POBLACION (TITAY)',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'POBLACION MUSLIM',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'PULIDAN',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'SUPIT',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'TUGOP',
    },
    {
        CITY: 'TITAY',
        BARANGAY: 'TUGOP MUSLIM',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'BALURAN',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'BATUNGAN',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'CAYAMCAM',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'DATU TUMANGGONG',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'GAYCON',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'LANGON',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'LIBERTAD (POB.)',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'LINGUISAN',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'LITTLE MARGOS',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'LOBOC',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'LOOC-LABUAN',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'LOWER TUNGAWAN',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'MALUNGON',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'MASAO',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'SISAY',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'TAGLIBAS',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'TIGBANUANG',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'TIGBUCAY',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'TIGPALAY',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'TIMBABAUAN',
    },
    {
        CITY: 'TUNGAWAN',
        BARANGAY: 'UPPER TUNGAWAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BAGONG BUHAY',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BELLA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'CALADES',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'DAWA-DAWA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'GULAYON',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'ILISAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'KAPATAGAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'KAWAYAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'LAMBUYOGAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'LAPIRAWAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'LITAYON',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'LUTIMAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'MILAGROSA (BALUNO)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'NAGA-NAGA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'PANDAN-PANDAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'PAYONGAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'TALAPTAP',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'TAMPALAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'TANDIONG MUSLIM',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'TIMBANG-TIMBANG',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'AGUADA',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BALATANAY',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BALUNO',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BEGANG',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BINUANGAN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'CABUNBATA',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'CALVARIO',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'CARBON',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'DIKI',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'DONA RAMONA T. ALANO (ISABELA WESTSITE)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'ISABELA EASTSIDE (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'ISABELA PROPER (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'KAPATAGAN GRANDE',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'KAPAYAWAN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'KAUMPURNAH ZONE I',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'KAUMPURNAH ZONE II',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'KAUMPURNAH ZONE III',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'KUMALARANG',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'LA PIEDAD (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'LAMPINIGAN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'LANOTE',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'LUKBUTON',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'LUMBANG',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'MAKIRI',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'MALIGUE (LUNOT)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'MARANG-MARANG',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'MARKETSITE (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'MASULA',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'MENZI',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'PANIGAYAN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'PANUNSULAN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'PORT AREA (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'RIVERSIDE',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'SEASIDE (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'SMALL KAPATAGAN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'SUMAGDANG',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'SUNRISE VILLAGE (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'TABIAWAN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'TABUK (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'TAMPALAN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'TIMPUL',
    }
];
